// extracted by mini-css-extract-plugin
module.exports = {"heading":"jobs_heading__10ugL","content":"jobs_content__3s4v1","button":"jobs_button__Y-SEa","sending":"jobs_sending__5xnXx"};